import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { StickyIcon } from 'site-modules/shared/components/sticky-icon/sticky-icon';

export function CtaButtonText({ text, hideOpenIcon = false, underlineText = false }) {
  return (
    <Fragment>
      {underlineText ? <span className="text-underline">{text}</span> : text}
      {!hideOpenIcon && <StickyIcon className="icon-open_in_new small" style={{ height: '12px', width: '12px' }} />}
    </Fragment>
  );
}

CtaButtonText.propTypes = {
  text: PropTypes.string.isRequired,
  hideOpenIcon: PropTypes.bool,
  underlineText: PropTypes.bool,
};
